import { render, staticRenderFns } from "./ComprovantePagamentoModal.vue?vue&type=template&id=9bbc459c"
import script from "./ComprovantePagamentoModal.vue?vue&type=script&lang=js"
export * from "./ComprovantePagamentoModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports